export default "__VITE_ASSET__BQEFKU1x__"